import { Stack, useTheme } from "@mui/material";
import { RecurringTicketFormSection } from "pages/modules/control-center/recurring-tickets/components/RecurringTicketFormSection";
import { useFormContext } from "react-hook-form";
import { TicketCreationType } from "../CreateTicketDrawer";
import { ChildTicketUserSearch } from "./ChildTicketUserSearch";
import { CustomerUserSearch } from "./CustomerUserSearch";
import { PriorityDescriptionSection } from "./PriorityDescriptionSection";
import { TemplateNameComponent } from "./TemplateNameComponent";
import { TemplateSummaryComponent } from "./TemplateSummaryComponent";
import { TicketSummaryComponent } from "./TicketSummaryComponent";

export const CreateTicketMainForm = ({
  type,
  lockMakeRecurringToggle = false,
}: {
  type: TicketCreationType;
  lockMakeRecurringToggle?: boolean;
}) => {
  const theme = useTheme();
  const { control } = useFormContext();

  return (
    <Stack
      sx={{
        height: "100%",
        p: "8px",
        gap: "8px",
      }}
    >
      {type !== "templateCreate" && type !== "templateEdit" ? (
        <>
          {type === "ticket" ? (
            <CustomerUserSearch type={type} />
          ) : (
            <ChildTicketUserSearch />
          )}
        </>
      ) : (
        <TemplateNameComponent />
      )}
      {type !== "templateCreate" && type !== "templateEdit" ? (
        <TicketSummaryComponent />
      ) : (
        <TemplateSummaryComponent />
      )}
      <PriorityDescriptionSection />
      {/* Control Center flow: render the "Select frequency" card inline.
          Normal ticket flow: handled by the sidebar "Recurring tickets" entry. */}
      {lockMakeRecurringToggle ? (
        <RecurringTicketFormSection lockToggle variant="card" />
      ) : null}
    </Stack>
  );
};
